import { Contact } from '@/types/address-book';

const DMP_CONTACT_PHONE_NUMBER = '22222222';

export const isDmpContact = (contact: Contact): boolean =>
  contact.phoneNumber === DMP_CONTACT_PHONE_NUMBER;

/**
 * A Contact is a discriminated union: it has either a phoneNumber or a
 * providerContact, never both. Resolve whichever is present for display.
 */
export const renderContactValue = (contact: Contact): string => {
  if (contact.phoneNumber !== undefined) {
    return isDmpContact(contact) ? 'DMP Contact' : contact.phoneNumber;
  }
  return contact.providerContact;
};
